import React from 'react';
// import { NavLink } from 'react-router-dom';

var bgimg1 = require('./../../images/background/bg5.jpg');

class AboutusDetails extends React.Component {
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding p-t80 p-b80 bg-gray">
                        <div className="container">
                            <div className="section-content">
                                <div className="row">
                                    <div className="col-xl-5 col-lg-5 col-md-12 ">
                                        <div className="home-2-about bg-bottom-left bg-no-repeat bg-cover" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                        </div>
                                    </div>
                                    <div className="col-xl-7 col-lg-7 col-md-12">
                                        <div className="about-home-2 p-t0 p-b0">
                                            <h3 className="m-t0 sx-tilte">About Us</h3>
                                            <p className='text-justify'>A professionally managed construction company with extensive experience in executing large- and medium-scale residential, commercial, and industrial projects.</p>
                                            <p className='text-justify'>The company is committed to excellence in every aspect of its operations, striving to deliver projects that meet the highest standards of quality and efficiency. Its approach emphasizes a process-oriented framework, ensuring streamlined operations and consistency across all projects.</p>
                                            <p className='text-justify'>With a focus on innovation and adherence to best practices, the organization takes pride in delivering superior outcomes while maintaining a strong commitment to safety. It prioritizes creating a safe and conducive work environment for all stakeholders, reflecting its dedication to workforce well-being and operational integrity.</p>
                                            <p className='text-justify'>By blending expertise, technology, and meticulous planning, the company aims to achieve exceptional customer satisfaction and contribute to sustainable development in the construction industry.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </>
        );
    }
};

export default AboutusDetails;